import { Outlet, Link, useLocation } from "react-router-dom";

function SignLayout() {
    const { pathname } = useLocation();

    let text = {};

    if(pathname === "/sign-up" || pathname === "/sign-up/verification-email"){
        text = {
            description: [
                "Welcome!",
                "Sign Up To",
                "GLMP Direct",
                "If you already have an account,",
                ""
            ],
            link: "Sign in here!",
            linkTarget: "/sign-in"
        }
    }else if(pathname === "/sign-in"){
        text = {
            description: [
                "Welcome back!",
                "Sign In To",
                "GLMP Direct",
                "If you don't have an account",
                "you can "
            ],
            link: "Sign up here!",
            linkTarget: "/sign-up"
        }
    }else if(pathname === "/mypage"){
        text = {
            description: [
                "Welcome back!",
                "Welcome!",
                "Welcome To GLMP."
            ]
        }
    }else if(pathname.includes("/forgot-password")){
        text = {
            description: [
                "Welcome back!",
                "Don't Remember",
                "Your Password?",
                "Don’t worry, it happens to the best of us."
            ]
        }
    }

    return (
        <div className="SignPage">
            <div className="LeftSection">
                <div className="LeftSection-Bg">
                    <div className="leftSection-Bg-Image" />
                </div>
                <div className="LeftSection-Content">
                    <div>
                        {text.description[0]}
                    </div>
                    <div>
                        <div>
                            {text.description[1]}
                        </div>
                        <div>
                            {text.description[2]}
                        </div>
                    </div>
                    <div>
                        <div>
                            {text.description[3]}&nbsp;
                        </div>
                        <div className="TextDecoration">
                            {text.description[4]}{text.link && <Link to={text.linkTarget}>{text.link}</Link>}
                        </div>
                         
                    </div>
                </div>
            </div>
            <div className="RightSection">
                <Outlet />
            </div>
        </div>
    );
}

export default SignLayout;